export default __webpack_public_path__ + "static/media/allgemein_32.6c9678bf.jpg";